module.exports = __webpack_public_path__ + "static/media/flat_white.b67cae77.svg";